var fn = function( obj ){
var __t,__p='';
__p+='#ifndef COLOR_INCLUDE\n#define COLOR_INCLUDE 1\n\nvec3 FastSRGBToLinear(vec3 c)\n{\n  return c * (c * (c * 0.305306011 + 0.682171111) + 0.012522878);\n}\n\n#endif\n';
return __p;
};
fn.toString=fn;
module.exports = fn;